// // import {OverlayTrigger, Tooltip } from "react-bootstrap";
// // import "./cardgrupo.css";
// // import LazyImage from "../../functions/LazyImage";

// // interface shopCardProps {
// //   onClick?: () => void; // Define the onClick prop as a function
// //   articuloGrupo: any;
// //   articulo?: any;
// //   inCard?:boolean
// // }
// // ShopCard.defaultProps = {
// //   name: "Default Name"
// // };

// // export default function ShopCard(props: shopCardProps) {
// //   const grupo = props.articuloGrupo;
// //   const articulo = props.articulo;
// //   // const [imageError, setImageError] = useState(false); // Estado para rastrear errores de imagen
// //   const cardContainerClass = `cardcontainer ${props.inCard ? 'with-border' : ''}`;

// //   function articuloId(): string {
// //     return grupo?.articuloGrupoId;
// //   }

// //   function articuloImagen(): string {
// //     return grupo?.articuloImagenV2 || grupo?.articuloGrupoImagenGXI || grupo?.articuloGrupoId?.articuloGrupoImagenGXI || "";
// //   }

// //   function articuloDescripcion(): string {
// //     return grupo?.articuloGrupoDescripcion;
// //   }

// //   // if (imageError) {
// //   //   return null; // No renderizar la tarjeta si hay un error de imagen
// //   // }


// //   return (
// //     <div className="card ht-300" id={grupo?.articuloCodigo} onClick={props.onClick}>
// //       <div className= {cardContainerClass}>
// //         <div className="picture-container">
// //           <LazyImage
// //             className="picture"
// //             key={articuloId()}
// //             src={`https://ferretera-img-web-prod.s3.sa-east-1.amazonaws.com/public/img/${articuloImagen()}`}
// //             alt="Lazy-loaded Image"
// //             onError={(e: any) => {
// //               e.target.src = `https://ferretera-img-web-prod.s3.sa-east-1.amazonaws.com/public/img/Imagenes/Grupos/noimg.png`;
// //               // setImageError(true); // Marcar error de imagen
// //             }}
// //           />
// //         </div>
// //         <div className="cardbody cardcontent">
// //           <div className="category">
// //             <span><strong>Grupo</strong></span>
// //           </div>
// //           <OverlayTrigger
// //             placement="top"
// //             overlay={<Tooltip>{articuloDescripcion()}</Tooltip>}
// //           >
// //             <div className="title mg-b-10">
// //               <h6>{articuloDescripcion()}</h6>
// //             </div>
// //           </OverlayTrigger>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./cardgrupo.css";
import LazyImage from "../../functions/LazyImage";
import { useMemo } from "react";

interface shopCardProps {
  onClick?: () => void;
  articuloGrupo: any;
  articulo?: any;
  inCard?: boolean;
  colorRandom?: boolean; 
  preCarga?:boolean
}

ShopCard.defaultProps = {
  name: "Default Name"
};

export default function ShopCard(props: shopCardProps) {
  const grupo = props.articuloGrupo;
  const articulo = props.articulo;

  const cardColors = ["rojo", "celeste", "amarillo", "marron", "negro"];

  // Color aleatorio solo si colorRandom es true
  const randomColorClass = useMemo(() => {
    if (props.colorRandom) {
      const index = Math.floor(Math.random() * cardColors.length);
      return `color-${cardColors[index]}`;
    }
    return "";
  }, [props.colorRandom]);

  const cardContainerClass = `cardcontainer wd-100p ${props.inCard ? "with-border" : ""} ${randomColorClass}`;

  function articuloId(): string {
    return grupo?.articuloGrupoId;
  }

  function articuloImagen(): string {
    return grupo?.articuloImagenV2 || grupo?.articuloGrupoImagenGXI || grupo?.articuloGrupoId?.articuloGrupoImagenGXI || "";
  }

  function articuloDescripcion(): string {
    return grupo?.articuloGrupoDescripcion;
  }

  return (
    <div className="card ht-300" id={grupo?.articuloCodigo} onClick={props.onClick}>
      <div className={cardContainerClass}>
        <div className="picture-container">
          {props.preCarga ? (
            // Precargar la imagen sin lazy loading
            <img
              className="picture"
              src={`https://ferretera-img-web-prod.s3.sa-east-1.amazonaws.com/public/img/${articuloImagen()}`}
              alt="Preloaded Image"
              onError={(e: any) => {
                e.target.src = `https://ferretera-img-web-prod.s3.sa-east-1.amazonaws.com/public/img/Imagenes/Grupos/noimg.png`;
              }}
              loading="eager" 
            />
          ) : (
            <LazyImage
              className="picture"
              key={articuloId()}
              src={`https://ferretera-img-web-prod.s3.sa-east-1.amazonaws.com/public/img/${articuloImagen()}`}
              alt="Lazy-loaded Image"
              onError={(e: any) => {
                e.target.src = `https://ferretera-img-web-prod.s3.sa-east-1.amazonaws.com/public/img/Imagenes/Grupos/noimg.png`;
              }}
            />
          )}
        </div>
        <div className="cardbody cardcontent">
          <div className="category">
            <span><strong>Grupo</strong></span>
          </div>
          <OverlayTrigger placement="top" overlay={<Tooltip>{articuloDescripcion()}</Tooltip>}>
            <div className="title mg-b-10">
              <h6>{articuloDescripcion()}</h6>
            </div>
          </OverlayTrigger>
        </div>
      </div>
    </div>
  );
}

